import { render, staticRenderFns } from "./FileDistUpload.vue?vue&type=template&id=e871ff44&scoped=true"
import script from "./FileDistUpload.vue?vue&type=script&lang=js"
export * from "./FileDistUpload.vue?vue&type=script&lang=js"
import style0 from "./FileDistUpload.vue?vue&type=style&index=0&id=e871ff44&prod&scoped=true&lang=css"
import style1 from "./FileDistUpload.vue?vue&type=style&index=1&id=e871ff44&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e871ff44",
  null
  
)

export default component.exports